<header class="header"
        #header>
  <dds-header [name]="headerOptions.name"
              [width]="headerOptions.width"
              [theme]="headerOptions.theme"
              [isResponsive]="headerOptions.isResponsive"
              [responsivePriority]="responsivePriority"
              #headerComponent>

    <dds-logo logo
              routerLink=""></dds-logo>

    <ng-container navigation>
      @for (page of pages; track page) {
      <dds-button [theme]="rla.isActive ? 'green' : 'dark'"
                  [kind]="rla.isActive ? 'primaryLoud' : 'silent'"
                  role="menuitem"
                  [isInverse]="true"
                  [routerLink]="page.path"
                  [routerLinkActiveOptions]="{exact: page.label === 'Home'}"
                  routerLinkActive
                  (click)="headerComponent.hideSticker()"
                  #rla="routerLinkActive">
        {{page.label}}
      </dds-button>
      }
    </ng-container>

    <app-search search
                class="header__search"></app-search>

    <ng-container profile>
      <dds-profile [username]="profileOptions.username" 
                   [nameLetter]="profileOptions.nameLetter"                   
                   [isInverse]="false"
                   [stickerIsDynamic]="true"
                   role="menuitem">                   
      </dds-profile>
    </ng-container>
  </dds-header>
</header>
